import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../api/api';

export const optionApi = createApi({
  reducerPath: 'optionApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Option'],
  endpoints: (builder) => ({
    getOptions: builder.query({
      query: (page = 1) => ({
        url: 'api/web/v1/site/option',
        method: 'GET',
        params: { page },
        tokenType: 'admin',
      }),
      providesTags: ['Option'],
    }),
    addOption: builder.mutation({
      query: (formData) => ({
        url: 'api/web/v1/site/add-option',
        method: 'POST',
        data: formData,
        isFormData: true,
        tokenType: 'admin',
      }),
      invalidatesTags: ['Option'],
    }),
    updateOption: builder.mutation({
      query: (formData) => ({
        url: 'api/web/v1/site/update-option',
        method: 'POST',
        data: formData,
        isFormData: true,
        tokenType: 'admin',
      }),
      invalidatesTags: ['Option'],
    }),
    deleteOption: builder.mutation({
      query: (formData) => ({
        url: 'api/web/v1/site/delete-option',
        method: 'POST',
        data: formData,
        isFormData: true,
        tokenType: 'admin',
      }),
      invalidatesTags: ['Option'],
    }),
  }),
});

export const {
  useGetOptionsQuery,
  useAddOptionMutation,
  useUpdateOptionMutation,
  useDeleteOptionMutation,
} = optionApi;
